<!-- =====================================================
     FOOTER — V Congreso Argentino de Agroecología
     Fondo: verde oliva oscuro (#2d3b1e)
     ===================================================== -->
<footer class="bg-[#2d3b1e] text-white">

  <!-- Main content -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
    <div class="grid grid-cols-2 gap-8 md:gap-16 lg:gap-24">

      <!-- ── Columna izquierda: Contacto ── -->
      <div>
        <h3 class="text-sm font-semibold uppercase tracking-wider text-gray-200 mb-4">
          Contacto
        </h3>
        <ul class="space-y-3">
          <!-- Email -->
          <li class="flex items-start gap-2.5">
            <svg class="w-4 h-4 mt-0.5 flex-shrink-0 text-gray-400"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.75">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/>
            </svg>
            <a href="mailto:info@congresoagroeco.org"
               class="text-sm text-gray-300 hover:text-white transition-colors break-all">
              info@congresoagroeco.org
            </a>
          </li>
          <!-- Ubicación -->
          <li class="flex items-start gap-2.5">
            <svg class="w-4 h-4 mt-0.5 flex-shrink-0 text-gray-400"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.75">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/>
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/>
            </svg>
            <span class="text-sm text-gray-300">La Plata, Argentina</span>
          </li>
          <!-- Teléfono -->
          <li class="flex items-start gap-2.5">
            <svg class="w-4 h-4 mt-0.5 flex-shrink-0 text-gray-400"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.75">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/>
            </svg>
            <a href="tel:+542210000000"
               class="text-sm text-gray-300 hover:text-white transition-colors">
              +54 221 000-0000
            </a>
          </li>
        </ul>
      </div>

      <!-- ── Columna derecha: Organizadores ── -->
      <div>
        <h3 class="text-sm font-semibold uppercase tracking-wider text-gray-200 mb-4">
          Organizadores
        </h3>

        <!-- Desktop: logos reales -->
        <!-- Reemplazar con los paths correctos de assets -->
        <div class="hidden md:flex flex-wrap items-center gap-4">
<!--          <img-->
<!--            src="assets/images/logo-saac.png"-->
<!--            alt="SAAC"-->
<!--            class="h-12 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"-->
<!--          />-->
<!--          <img-->
<!--            src="assets/images/logo-fcayf.png"-->
<!--            alt="FCAYF – Facultad de Ciencias Agrarias y Forestales"-->
<!--            class="h-12 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"-->
<!--          />-->
<!--          <img-->
<!--            src="assets/images/logo-unlp.png"-->
<!--            alt="UNLP – Universidad Nacional de La Plata"-->
<!--            class="h-12 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"-->
<!--          />-->
        </div>

        <!-- Mobile: badges de texto (como en el diseño) -->
        <div class="flex md:hidden flex-wrap gap-2">
          <span class="border border-gray-500 text-gray-300 text-xs font-medium px-2.5 py-1 rounded">
            UNLP
          </span>
          <span class="border border-gray-500 text-gray-300 text-xs font-medium px-2.5 py-1 rounded">
            FCAYF
          </span>
          <span class="border border-gray-500 text-gray-300 text-xs font-medium px-2.5 py-1 rounded">
            SAAE
          </span>
        </div>
      </div>

    </div>
  </div>

  <!-- Copyright bar -->
  <div class="border-t border-white/10 py-4 px-4">
    <p class="text-center text-xs text-gray-500">
      © 2023 V Congreso Argentino de Agroecología. Todos los derechos reservados.
    </p>
  </div>

</footer>
